module.exports = __webpack_public_path__ + "assets/img/8b652431bf15a37181bf90cdd6455587.svg";